import { render } from "./RoutersTab.vue?vue&type=template&id=67f1c126&scoped=true"
import script from "./RoutersTab.vue?vue&type=script&lang=js"
export * from "./RoutersTab.vue?vue&type=script&lang=js"

import "./RoutersTab.vue?vue&type=style&index=0&id=67f1c126&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f1c126"]])

export default __exports__